<template>
  <div id="country" class="img-container">
    <img src="@/assets/intro/country/south-america.png" class="south-america" alt="">
  </div>
</template>

<script>
import backgroundAnimation from './background-animation'

export default {
  name: 'CountryBackground',
  mixins: [backgroundAnimation],
  mounted () {
    this.backgroundAnimation(
      'country',
      0.1,
      2,
      'display-country-background'
    )
  }
}
</script>

<style scoped lang="sass">
  @tailwind utilities

  $container-height: 16rem

  .img-container
    @apply absolute half-t -translate-y-50 w-screen
    height: $container-height
    left: $mobile-background-transition-distance * 5
    & > *
      @apply absolute

  .south-america
    left: 20%
    top: calc(-50vh + #{$container-height / 2})
    width: 80vw
    @screen sm-l
      width: 50vw
      left: 45%
    @screen md
      left: 30%
      width: 60vw
    @screen lg
      right: -13%
      width: 46vw
    @screen xl
      top: calc(-50vh + #{$container-height / 2} - 5vh)
    @screen xxl
      width: 52rem
      right: -9%
    @screen xxxl
      top: calc(-55vh + #{$container-height / 2})
</style>
